/** Calculation methods */

/**
 * Round number with fixed decimal places
 * @param {Number} num Rounding number
 * @param {Number} decimals Non-negative integer number of decimal places
 */
export const roundTo = (num, decimals) => {
  const f = Math.pow(10, decimals);
  return Math.round(num * f) / f;
};

/**
 * Check are two numbers the same with accounting first 'accuracy' digits
 * @param {Number} a First number
 * @param {Number} b Second number
 * @param {Number} accuracy Count of significant digits to equaling
 * @returns {Boolean}
 */
export const equalRounded = (a, b, accuracy) => {
  return roundTo(a, accuracy) === roundTo(b, accuracy);
};

export const getBounded = (num, min, max) => {
  return Math.max(Math.min(num, max), min);
};

export const alignByStep = (n, step) => {
  return align(n, step, Math.round);
};

export const alignUpByStep = (n, step) => {
  return align(n, step, Math.ceil);
};

export const alignDownByStep = (n, step) => {
  return align(n, step, Math.floor);
};

function align(n, step, roundFunc = Math.round) {
  return roundFunc(n / step) * step;
}
